import React, { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { fetchReceivedPaymentcollectionList } from "../../services/AccountServices";
import config from "../common/Config";
import * as XLSX from "xlsx";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import Select from "react-select";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/dist/rsuite.min.css";

const PaymentProcess = () => {
  const [reportrange, setReportrange] = useState("");
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [draw] = useState(1);
  const [start] = useState(0);
  const [length] = useState(5000);
  const accessToken = localStorage.getItem("accessToken");

  const [receivedPayment, setReceivedPayment] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [shouldLoadPayments, setShouldLoadPayments] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [customerFilter, setCustomerFilter] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState(null);
  const [salesrepOptions, setSalesrepOptions] = useState([]);
  const [salesrepInputValue, setSalesrepInputValue] = useState(null);
  
  const searchFormData = () => {
    const startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
    const endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";
    setReportrange(startDate ? `${startDate} - ${endDate}` : "");
    setShouldLoadPayments(true);
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    if (isInitialLoad) {
      loadReceivedPaymentList();
      setIsInitialLoad(false);
    } else if (shouldLoadPayments) {
      loadReceivedPaymentList();
      setShouldLoadPayments(false);
    }
  }, [shouldLoadPayments, accessToken, isInitialLoad]);

  const loadReceivedPaymentList = async () => {
    try {
      const customer = customerInputValue ? customerInputValue.value : "";
      const salesrep = salesrepInputValue ? salesrepInputValue.value : "";
      const data = await fetchReceivedPaymentcollectionList(
        draw,
        start,
        length,
        reportrange,
        accessToken,
        customer,
        salesrep
      );
      setReceivedPayment(data);
      setFilteredData(data);
    } catch (error) {
      console.error("Failed to load received payment list:", error);
    }
  };

  useEffect(() => {
    const table = $("#PaymentCollection").DataTable({
      destroy: true,
      data: filteredData,
      columns: [
        { data: "date" },
        { data: "customer" },
        { data: "route" },
       
        { data: "collected_by" },
        { data: "mode" },
        { data: "total_due" },
        { data: "amount" },
      ],
      columnDefs: [
        { targets: 0, width: "60px" },
        { targets: 1, width: "300px" },
        { targets: 2, width: "100px" },
        { targets: 5, width: "100px" },
      ],
      paging: true,
      searching: false,
      ordering: false,
      info: true,
      pageLength: 50,
      lengthChange: false,
      footerCallback: function (row, data, start, end, display) {
        let total = 0;
        let totalCash = 0;
        let totalCheque = 0;
        let totalCard = 0;
        let totalBankTransfer = 0;
        data.forEach((row) => {
          const amount = parseFloat(row.amount) || 0;
          total += amount;

          const mode = row.mode?.toLowerCase();
          if (mode === "cash") {
            totalCash += amount;
          } else if (mode === "cheque") {
            totalCheque += amount;
          }else if (mode === "card" || mode === "cc") {
            totalCard += amount;
          }else if (mode === "bank transfer") {
            totalBankTransfer += amount; // Assuming bank transfer is treated like cheque
          }
        });

        const formattedTotal = total.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        $("#totalAmountFooter").html(formattedTotal);
        $("#totalAmount").html(formattedTotal);
        $("#totalcash").html(
          totalCash.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalcard").html(
          totalCard.toLocaleString("en-IN", {
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2,
          })
        );
        $("#totalcheque").html(
          totalCheque.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
        $("#totalbanktransfer").html(
          totalBankTransfer.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      },
    });

    return () => {
      table.destroy();
    };
  }, [filteredData]);

  const fetchCustomerNameOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return;

    const formData = new FormData();
    formData.append("term", inputValue);
    formData.append("limit", "10");

    try {
      const response = await fetch(`${config.API_URL}/suggestions`, {
        method: "POST",
        headers: { authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      if (Array.isArray(data.results)) {
        const formattedOptions = data.results.map((item) => ({
          label: item.text,
          value: item.id,
        }));
        setCustomerOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching customer options:", error);
    }
  };

  const exportToExcel = () => {
    const exportData = filteredData.map((item, i) => ({
      Sr: i + 1,
      Date: item.date || "",
      Customer: item.customer || "",
      Route: item.route || "",
      "Collected By": item.collected_by || "",
      Mode: item.mode || "",
      "Total Due": parseFloat(item.total_due) || "",
      Amount: parseFloat(item.amount) || 0,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Payments");
    XLSX.writeFile(wb, "PaymentCollection.xlsx");
  };

  const handleInputChange = (inputValue) => {
    if (inputValue && inputValue.length >= 3) {
      fetchCustomerNameOptions(inputValue);
    }
  };

  const handleChange = (selectedOption) => {
    setCustomerInputValue(selectedOption);
    setCustomerFilter(selectedOption?.label || "");
  };

  const handleDateChange = (value) => {
    setDates(value);
  };

  const handleSalesrepChange = (selectedOption) => {
    setSalesrepInputValue(selectedOption);
  };

  const fetchSalesreps = async () => {
    try {
      const response = await fetch(`${config.API_URL}/getSalesRep`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      setSalesrepOptions(
        Array.isArray(data.data)
          ? data.data.map((rep) => ({
              value: rep.id,
              label: `${rep.first_name}${
                rep.last_name ? " " + rep.last_name : ""
              }`.trim(),
            }))
          : []
      );
    } catch (error) {
      setSalesrepOptions([]);
      console.error("Error fetching sales reps:", error);
    }
  };

  useEffect(() => {
    fetchSalesreps();
  }, [accessToken]);

  useEffect(() => {
    let filtered = receivedPayment;
    if (customerFilter) {
      filtered = filtered.filter((item) =>
        item.customer?.toLowerCase().includes(customerFilter.toLowerCase())
      );
    }
    if (salesrepInputValue?.label) {
      filtered = filtered.filter(
        (item) =>
          item.collected_by?.toLowerCase() ===
          salesrepInputValue.label.toLowerCase()
      );
    }
    setFilteredData(filtered);
  }, [customerFilter, salesrepInputValue, receivedPayment]);

  return (
    <>
      <Header />
      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Link to="/Dashboard">
                <i className="fa fa-home"></i>
              </Link>
              <Link to="#">Account</Link>
              <Link to="#">Payments Collection</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container">
        <div className="container-fluid">
          <div className="backlist-content-area">
            <div className="row mb-3 align-items-end">
              <div className="col-md-2">
                <label className="form-label">
                  <b>Date</b>
                </label>
                <DateRangePicker
                  value={dates}
                  placeholder="DD/MM/YYYY - DD/MM/YYYY"
                  onChange={handleDateChange}
                  format="dd/MM/yyyy"
                  character=" - "
                  style={{ width: "100%" }}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  <b>Customer</b>
                </label>
                <Select
                  isClearable
                  onInputChange={handleInputChange}
                  onChange={handleChange}
                  options={customerOptions}
                  placeholder="Search..."
                  value={customerInputValue}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label">
                  <b>Collected By</b>
                </label>
                <Select
                  isClearable
                  onChange={handleSalesrepChange}
                  options={salesrepOptions}
                  placeholder="Search..."
                  value={salesrepInputValue}
                />
              </div>

              <div className="col-md-1 text-end">
                <button className="acceptbtn" onClick={searchFormData}>
                  Submit
                </button>
              </div>

              <div className="col-md-3 text-end">
                
              </div>

              <div className="col-md-1 text-end">
                <button className="acceptbtn" onClick={exportToExcel}>
                  Export
                </button>
              </div>
            </div>
            <div className="row" style={{ marginBottom: "-20px" }}>
              <div className="col-md-12">
                  
                <label className="form-label">
                   Cash:{" "}
                  <b
                    id="totalcash"
                    style={{ marginLeft: "5px", marginRight: "10px" }}
                  ></b>
                </label>
                <span> | </span>
                <label className="form-label">
                   Card:{" "}
                  <b
                    id="totalcard"
                    style={{ marginLeft: "5px", marginRight: "10px" }}
                  ></b>
                </label>
                <span> | </span>
                <label className="form-label">
                   Cheque: <b id="totalcheque"></b>
                </label>
                 <span> | </span>
                <label className="form-label">
                   Bank Transfer: <b id="totalbanktransfer"></b>
                </label>
                <span> | </span>
                <label className="form-label">
                   Total Amount: <b id="totalAmount"></b>
                </label>
              </div>
            </div>
            <div
              className="verical-scrl-wrapper autoheight-table payment-collection-list"
              id="style-3"
            >
              <table
                className="table table-bordered dataTable resizable"
                id="PaymentCollection"
              >
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Customer Name(A/C No)</th>
                    <th>Route</th>
                   
                    <th>Collected By</th>
                    <th>Mode</th>
                     <th>Amount Due</th>
                    <th>Collected Amt</th>
                  </tr>
                </thead>
                <tbody></tbody>
                <tfoot>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th style={{ textAlign: "right" }}>Total:</th>
                    <th
                      style={{ textAlign: "right" }}
                      id="totalAmountFooter"
                    ></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentProcess;
